module.exports = __webpack_public_path__ + "assets/img/applyDui.4d744fcd.png";